"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EnhancedTableToolbar;
var _material = require("@mui/material");
var _Button = _interopRequireDefault(require("../Button/Button"));
var _styles = require("@mui/styles");
var _react = _interopRequireDefault(require("react"));
var styles = (0, _styles.makeStyles)(function (theme) {
  return {
    toolbar: {
      background: '#EDF0F1'
    },
    flexText: {
      flex: '1 1 auto'
    },
    buttonSpacing: {
      marginLeft: theme.spacing(1)
    }
  };
});
function EnhancedTableToolbar(props) {
  var numSelected = props.numSelected,
    renderNumSelectedText = props.renderNumSelectedText,
    topBarButtons = props.topBarButtons;
  var classes = styles();
  return renderNumSelectedText && numSelected > 0 ? /*#__PURE__*/_react.default.createElement(_material.Toolbar, {
    className: classes.toolbar
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: "inherit",
    variant: "subtitle1",
    component: "div",
    className: classes.flexText
  }, renderNumSelectedText(numSelected)), topBarButtons === null || topBarButtons === void 0 ? void 0 : topBarButtons.map(function (tbButton) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: classes.buttonSpacing,
      key: tbButton.buttonText,
      label: tbButton.buttonText,
      priority: "secondary",
      type: tbButton.buttonType,
      onClick: tbButton.onButtonClick,
      icon: tbButton.icon,
      disabled: tbButton.disabled
    });
  })) : null;
}